
import {defineComponent} from "vue";
import SimpleTextCbCustom from "@/components/layouts/content-blocks/simple-content-blocks/SimpleTextCbCustom.vue";

export default defineComponent({
  name: "CustomJs",
  components: {SimpleTextCbCustom},
});
